import { useQuery } from '@zg-rentals/react-query5';

import type { PropertiesPaymentResponseDto } from '../../types/PropertiesPaymentDto';

type UseGetPropertiesPaymentParams = {
  groupId: string;
  listingAlias?: string;
};

export const useGetPropertiesPayment = ({ groupId, listingAlias }: UseGetPropertiesPaymentParams) => {
  const { data, isPending, isError, isFetching } = useQuery<PropertiesPaymentResponseDto, Error>({
    queryKey: ['getPropertiesPayment', groupId, listingAlias],
    queryFn: async () => {
      // TODO: Replace with real v2 endpoint when available
      const { mockRentalManagerAccountViewZrmWebApiHandlerV2_propertiesPayment } = await import(
        '../../api/mockPropertiesPaymentApi'
      );
      return mockRentalManagerAccountViewZrmWebApiHandlerV2_propertiesPayment({
        groupId,
        listingAlias,
      });
    },
    // Keep previous data during refetch to prevent UI flicker
    placeholderData: (previousData) => previousData,
  });

  return {
    data,
    isPending,
    isFetching,
    isError,
  };
};
